module.exports = __webpack_public_path__ + "static/media/Language.67deb3f1.png";